import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const MondayIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.92239 19.365C2.40023 19.3642 1.8878 19.2237 1.43824 18.9581C0.988669 18.6925 0.618331 18.3115 0.365625 17.8546C0.112919 17.3976 -0.012956 16.8814 0.00105402 16.3595C0.015064 15.8375 0.168449 15.3288 0.445303 14.886L5.71107 6.47666C6.12299 5.8189 6.77933 5.35171 7.53571 5.17787C7.91023 5.09179 8.29804 5.08033 8.67699 5.14413C9.05594 5.20793 9.41862 5.34574 9.74431 5.5497C10.07 5.75367 10.3523 6.01978 10.5752 6.33286C10.798 6.64593 10.957 6.99983 11.0431 7.37435C11.1292 7.74888 11.1406 8.13668 11.0768 8.51564C11.013 8.89459 10.8752 9.25727 10.6713 9.58296L5.40429 17.9923C5.14109 18.413 4.77516 18.7597 4.34096 18.9998C3.90676 19.24 3.41858 19.3657 2.92239 19.365Z",
                fill: "#FF3D57"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.9965 19.3656C11.474 19.3656 10.9609 19.2258 10.5107 18.9605C10.0604 18.6953 9.68941 18.3143 9.43613 17.8573C9.18285 17.4002 9.05655 16.8836 9.07036 16.3612C9.08416 15.8388 9.23757 15.3297 9.51464 14.8866L14.784 6.47723C14.9794 6.13438 15.2421 5.83459 15.5563 5.5959C15.8706 5.35722 16.2299 5.18456 16.6126 5.08833C16.9953 4.9921 17.3935 4.97428 17.7832 5.03594C18.173 5.0976 18.5463 5.23747 18.8806 5.44714C19.2149 5.6568 19.5033 5.93193 19.7286 6.25596C19.9538 6.57999 20.1111 6.94623 20.1911 7.33265C20.2711 7.71907 20.2721 8.11769 20.1941 8.50451C20.1161 8.89133 19.9606 9.25836 19.737 9.58353L14.4772 17.9929C14.214 18.4135 13.8481 18.7603 13.4139 19.0004C12.9797 19.2405 12.4927 19.3662 11.9965 19.3656Z",
                fill: "#FFCB00"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.0693 19.3649C22.6879 19.3649 24 18.0857 24 16.5077C24 14.9296 22.6879 13.6504 21.0693 13.6504C19.4508 13.6504 18.1387 14.9296 18.1387 16.5077C18.1387 18.0857 19.4508 19.3649 21.0693 19.3649Z",
                fill: "#00D647"
            })
        ]
    });
};
